export default __webpack_public_path__ + "static/pentaho-4930091d1a2fa7396ec0b10ae428e3bd.png";